import { Button, Flex, Form, Radio, Table, Typography } from "antd";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  RocketOutlined,
  CheckOutlined
} from "@ant-design/icons";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
import { getSubscriptionPlansAction } from "../../../../../redux/services/subscription-plan/subscriptionPlanServices";
import { IconOffer, ProMembershipIcon } from "../../../../../assets/svg";
import { colors } from "../../../../../constants/colors";
import Spinner from "../../../../common/spinner/Spinner";

const SubscriptionPlanList = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { tickets } = useSelector((state) => state.tickets);
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: tickets?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  const { subscriptionPlans, selectedSubscriptionPlanLogDetails } = useSelector((state) => state.subscriptionPlans);


  /* function definition to get table data */
  const handleGetTableData = useCallback(() => {
    const dataToBeSent = {
      type: selectedSubscriptionPlanLogDetails?.selectedCurrentSubscriptionPlanId,
    };
    dispatch(getSubscriptionPlansAction(dataToBeSent, setLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /* function definition to get table data */

  useEffect(()=>{
    handleGetTableData();
  },[])

  const subscriptionCodes = {
    "FREE": {
      icon: <IconOffer fillColor={colors.deepSafron} />,
      color: colors.deepSafron,
      lightColor: colors.lightBeige,
    },
    "PREMIUM": {
      icon: (
        <RocketOutlined style={{ color: colors.royalPurple, fontSize: 20 }} />
      ),
      color: colors.royalPurple,
      lightColor: colors.lavenderBlue,
    },
    "ELITE-PREMIUM": {
      icon: <ProMembershipIcon fillColor={colors.turquoise} />,
      color: colors.turquoise,
      lightColor: colors.lightCyan,
    },
  };

  return (
    <Flex gap="2rem" justify="space-between">
        <Flex gap="1rem">
            <Button
              type="default"
              shape="circle"
              size="small"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate(selectedSubscriptionPlanLogDetails?.navigateBack)}
            />
            </Flex>
      {loading ? (
        <Spinner/>
      ) : (
          subscriptionPlans && Object.keys(subscriptionPlans)?.length !== 0 &&
          <div
          className="cardContainer"
          style={{
            width: 400,
            height: 500,
            boxShadow: "1px 4px 8px rgba(0,0,0,0.1)",
            background: "#F5F5F5",
            border: `1px solid ${
              subscriptionCodes[selectedSubscriptionPlanLogDetails?.selectedCurrentSubscriptionPlanId]?.color
            }`,
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            padding: 20,
            borderRadius: 20,
          }}
        >
          <Flex gap="1rem" vertical>
            <Flex gap="1rem" align="center">
              <div
                style={{
                  borderRadius: "50%",
                  border: `4px solid ${
                    subscriptionCodes[selectedSubscriptionPlanLogDetails?.selectedCurrentSubscriptionPlanId]?.color
                  }`,
                  width: 40,
                  height: 40,
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {subscriptionCodes[selectedSubscriptionPlanLogDetails?.selectedCurrentSubscriptionPlanId]?.icon}
              </div>
              <Typography.Title level={2}>
                {subscriptionPlans?.data[0]?.name}
              </Typography.Title>
            </Flex>

            <div>
              {subscriptionPlans?.data[0]?.features &&
                subscriptionPlans?.data[0]?.features?.map((feature, index) => (
                  <Flex gap="1rem">
                    <CheckOutlined
                      style={{
                        color:
                          subscriptionCodes[selectedSubscriptionPlanLogDetails?.selectedCurrentSubscriptionPlanId]
                            ?.color,
                        background:
                          subscriptionCodes[selectedSubscriptionPlanLogDetails?.selectedCurrentSubscriptionPlanId]
                            ?.lightColor,
                        borderRadius: "50%",
                        width: 25,
                        height: 25,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                    <Typography.Paragraph key={index}>
                      {feature}
                    </Typography.Paragraph>
                  </Flex>
                ))}
            </div>
            <Flex vertical align="center" justify="center" gap="1rem">
              <Typography.Title
                level={3}
                style={{ color: colors.gunMetalGray, margin: 0 }}
              >
                No. of users : {subscriptionPlans?.data[0]?.number_of_logins}
              </Typography.Title>
            </Flex>
            <Flex vertical align="center" justify="center" gap="1rem">
            {subscriptionPlans?.data[0]?.pricing &&
              subscriptionPlans?.data[0]?.pricing?.map((element) => {
                return (
                  <Typography.Title
                    level={2}
                    style={{
                      color:
                        subscriptionCodes[selectedSubscriptionPlanLogDetails?.selectedCurrentSubscriptionPlanId]
                          ?.color,
                      margin: 0,
                    }}
                  >
                    {`${element?.price} ${element?.currency} for ${element?.duration} ${element?.duration_unit}`}
                  </Typography.Title>
                );
              })}
            </Flex>
          </Flex>
        </div>
      )}
      <div>
        
      </div>
    </Flex>
  );
};

export default SubscriptionPlanList;
